
import { useRef, useState } from 'react';
import { Button, Col, Form, Row, Popover } from 'react-bootstrap';
import Select from 'react-select';

import { ModalFiltrosComponent, PopoverFiltrosComponent } from './components';

import { intersectObject } from '../../../../Funcoes';

import InputDataCombo from "../../../../Componentes/InputDataCombo";
import ComboIntegracaoSistemas from '../../../../Componentes/ComboIntegracaoSistemas';

export default function ModalFiltros({
    elemento,
    mostrar,
    alterarMostrar,
    parametros,
    alterarParametros
}){

    // estados
    const [ filtros, alterarFiltros ] = useState(intersectObject({
        pesquisa: null,
        status: null,
        idsIntegracaoSistema: null,
        dataPedidoInicio: null,
        dataPedidoFinal: null,
        dataConcluidoInicio: null,
        dataConcluidoFinal: null
    }, parametros ?? {}));
    const refs = {
        dataPedidoInicioCol: useRef(null),
        dataPedidoFinalCol: useRef(null),
        dataConcluidoInicioCol: useRef(null),
        dataConcluidoFinalCol: useRef(null)
    };

    // prepara filtro de status
    const status = [
        {label: 'Concluído', value: 'concluido'},
        {label: 'Aguardando', value: 'aguardando'},
        {label: 'Integrando', value: 'integrando'},
        {label: 'Atraso', value: 'emAtraso'},
        {label: 'Cancelado', value: 'cancelado'}
    ];

    // função para limpar os filtros
    function limparFiltros(){

        // prepara
        let filtrosAlterar = {...filtros};

        // percorre filtros
        Object.keys(filtros).map((filtro) => {

            // limpa
            filtrosAlterar[filtro] = null;

        });

        // altera
        alterarFiltros({...filtrosAlterar});
        // alterarParametros({...parametros, ...filtrosAlterar});

    }

    // função para cancelar (sair sem aplicar)
    function cancelar(){

        // fecha
        alterarMostrar(false);

        // altera os filtros para o estado inicial
        let filtrosAlterar = {...filtros};
        let parametrosClone = {...parametros};

        // percorre
        Object.keys(filtros).map((filtro) => {

            // altera
            filtrosAlterar[filtro] = parametrosClone[filtro] ?? null;
        });

        // altera os filtros
        alterarFiltros({...filtrosAlterar});

    }

    return <ModalFiltrosComponent
        show={mostrar}
        target={elemento}
        placement="bottom"
        rootClose
        onHide={() => {
            cancelar();
        }}
    >
        <PopoverFiltrosComponent
            size={'sm'}
            title={'Filtros'}
        >
            <Popover.Title>
                Filtros
                <Button
                    size="sm"
                    name="botao-limpar"
                    onClick={() => {

                        // limpa filtros
                        limparFiltros();
                    }}
                >
                    Limpar
                </Button>
            </Popover.Title>
            <Popover.Content>
                <Row>
                    <Col>
                        <Form.Label>Pesquisa <small>(empresa/usuário)</small></Form.Label>
                        <Form.Control 
                            value={filtros.pesquisa || ''}
                            onChange={e => {

                                // altera
                                alterarFiltros({...filtros, pesquisa: e.target.value});
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Status</Form.Label>
                        <Select
                            className="select-ficha"
                            size="sm"
                            options={status}
                            value={status.filter((s) => filtros.status && filtros.status.includes(s.value))}
                            isMulti={true}
                            placeholder='Sem filtro'
                            onChange={(opcoes) => {
                                
                                // altera os filtros selecionados
                                alterarFiltros({
                                    ...filtros,
                                    status: (
                                        opcoes ? opcoes.map((s) => s.value) : null
                                    )
                                });
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Integração</Form.Label>
                        <ComboIntegracaoSistemas
                            className="select-ficha"
                            isMulti={true}
                            valor={filtros.idsIntegracaoSistema}
                            aoAlterar={(idsIntegracaoSistema) => {
                                
                                // altera
                                alterarFiltros({
                                    ...filtros,
                                    idsIntegracaoSistema
                                });
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Data pedido</Form.Label>
                        <Row>
                            <Col className='position-relative' ref={refs.dataPedidoInicioCol}>
                                {refs.dataPedidoInicioCol.current && <InputDataCombo
                                    size="sm"
                                    placeholder="A partir de"
                                    data={filtros.dataPedidoInicio}
                                    onChange={(novaData) => {
                                        alterarFiltros({...filtros, dataPedidoInicio: novaData})
                                    }}
                                    options={{
                                        appendTo: refs.dataPedidoInicioCol.current
                                    }}
                                />}
                            </Col>
                            <Col className='position-relative' ref={refs.dataPedidoFinalCol}>
                                {refs.dataPedidoFinalCol.current && <InputDataCombo
                                    size="sm"
                                    placeholder="Até"
                                    data={filtros.dataPedidoFinal}
                                    onChange={(novaData) => {
                                        alterarFiltros({...filtros, dataPedidoFinal: novaData})
                                    }}
                                    options={{
                                        appendTo: refs.dataPedidoFinalCol.current
                                    }}
                                />}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Data concluído</Form.Label>
                        <Row>
                            <Col className='position-relative' ref={refs.dataConcluidoInicioCol}>
                                {refs.dataConcluidoInicioCol.current && <InputDataCombo
                                    size="sm"
                                    placeholder="A partir de"
                                    data={filtros.dataConcluidoInicio}
                                    onChange={(novaData) => {
                                        alterarFiltros({...filtros, dataConcluidoInicio: novaData})
                                    }}
                                    options={{
                                        appendTo: refs.dataConcluidoInicioCol.current
                                    }}
                                />}
                            </Col>
                            <Col className='position-relative' ref={refs.dataConcluidoFinalCol}>
                                {refs.dataConcluidoFinalCol.current && <InputDataCombo
                                    size="sm"
                                    placeholder="Até"
                                    data={filtros.dataConcluidoFinal}
                                    onChange={(novaData) => {
                                        alterarFiltros({...filtros, dataConcluidoFinal: novaData})
                                    }}
                                    options={{
                                        appendTo: refs.dataConcluidoFinalCol.current
                                    }}
                                />}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <div className='footer'>
                    <Button
                        size="sm"
                        variant={'light'}
                        onClick={() => {

                            // cancela
                            cancelar();
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        size="sm"
                        variant={'success'}
                        onClick={() => {

                            // altera os parâmetros
                            alterarParametros({...parametros, ...filtros, pagina: 1});
                        }}
                    >
                        Aplicar
                    </Button>
                </div>
            </Popover.Content>
        </PopoverFiltrosComponent>
    </ModalFiltrosComponent>
    
}